import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const dict = {
  es: {
    properties: "Propiedades", zones: "Zonas", services: "Servicios", guide: "Guía", contact: "Contacto",
    publish: "Soy Propietario", search: "Buscar", zone: "Zona", type: "Tipo", bedrooms: "Habitaciones",
    minPrice: "Precio mín.", maxPrice: "Precio máx.", furnished: "Amueblada", any: "Cualquiera",
    details: "Ver detalles", whatsapp: "WhatsApp", perMonth: "/mes", featured: "Propiedades destacadas",
  },
  en: {
    properties: "Properties", zones: "Areas", services: "Services", guide: "Guide", contact: "Contact",
    publish: "I'm an Owner", search: "Search", zone: "Area", type: "Type", bedrooms: "Bedrooms",
    minPrice: "Min price", maxPrice: "Max price", furnished: "Furnished", any: "Any",
    details: "View details", whatsapp: "WhatsApp", perMonth: "/mo", featured: "Featured properties",
  },
};

const SiteCtx = createContext({ settings: {}, lang: "es", t: (k) => k, setLang: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [lang, setLangState] = useState(localStorage.getItem("srpc_lang") || "es");
  useEffect(() => {
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => { localStorage.setItem("srpc_lang", l); setLangState(l); };
  const t = (k) => dict[lang]?.[k] || dict.es[k] || k;
  return <SiteCtx.Provider value={{ settings, lang, setLang, t }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
